import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-nome-fantasia',
  templateUrl: './text-nome-fantasia.component.html',
  styleUrls: ['./text-nome-fantasia.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNomeFantasiaComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
